import http from "./apiClient";

export const getNoctisOutboxStatus = async () => {
  const res = await http.get("/noctis/outbox/status");
  return res?.data;
};

export const listNoctisOutboxItems = async ({ status, limit } = {}) => {
  const params = {};
  if (status) params.status = status;
  if (limit != null) params.limit = limit;
  const res = await http.get("/noctis/outbox", { params });
  return res?.data;
};
